if (!customElements.get('vp-features-carousel')) {
  customElements.define(
    'vp-features-carousel',
    class VpFeaturesCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vp-features-track]');
        if (!this.track) return;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        this.track.addEventListener('pointerdown', this.onPointerDown);
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('pointerdown', this.onPointerDown);
        this.teardownDrag();
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (window.matchMedia('(min-width: 990px)').matches) return;

        this.dragging = true;
        this.startX = event.clientX;
        this.startScroll = this.track.scrollLeft;
        this.moved = false;
        this.track.setPointerCapture(event.pointerId);
        this.track.addEventListener('pointermove', this.onPointerMove);
        this.track.addEventListener('pointerup', this.onPointerUp);
        this.track.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        const delta = event.clientX - this.startX;
        if (Math.abs(delta) > 4) this.moved = true;
        this.track.scrollLeft = this.startScroll - delta;
      }

      onPointerUp(event) {
        if (!this.dragging) return;
        this.dragging = false;
        this.teardownDrag();
        if (this.moved) {
          event.preventDefault();
        }
      }

      teardownDrag() {
        if (!this.track) return;
        this.track.removeEventListener('pointermove', this.onPointerMove);
        this.track.removeEventListener('pointerup', this.onPointerUp);
        this.track.removeEventListener('pointercancel', this.onPointerUp);
      }
    }
  );
}
